function getBorderWidth(width) {
  // Although falsy, 0 is a valid value for a border width.
  if (width === 0) return 0

  // Historically blockquotes used a 5px border width.
  return width || 5
}

export default function borderStyles(find) {
  const width = find("blockquote", "borderLeftWidth")
  const color = find("blockquote", "borderLeftColor")

  return {
    borderLeftStyle: "solid",
    borderLeftWidth: getBorderWidth(width),
    borderLeftColor: color || "#e1e1e1"
  }
}
